import React from "react";
import store from "../../../store/index";
import { Redirect } from "react-router-dom";
import authorizedComponent from "../../../helpers/authorized-component";

const checkUserPermissions = (component, componentName) => {
  const mainStore = store.getState().main;
  if (
    !authorizedComponent.isUserHasPermission(
      componentName,
      mainStore.permissionsUser
    )
  ) {
    return {
      status: false,
      routeObject: <Redirect to="/unauthorized" />,
    };
  }

  return {
    status: true,
    routeObject: component,
  };
};

const hasToken = (component) => {
  const searchParams = new URLSearchParams(window.location.search);
  const token = searchParams.get("token");
  if (token == null) {
    return {
      status: false,
      routeObject: <Redirect to="/login" />,
    };
  }

  if (token == "") {
    return {
      status: false,
      routeObject: <Redirect to="/login" />,
    };
  }

  return {
    status: true,
    routeObject: component,
  };
};

export default {
  checkUserPermissions,
  hasToken,
};
